import { render, staticRenderFns } from "./OTAHome.vue?vue&type=template&id=67caa142&scoped=true"
import script from "./OTAHome.vue?vue&type=script&lang=js"
export * from "./OTAHome.vue?vue&type=script&lang=js"
import style0 from "./OTAHome.vue?vue&type=style&index=0&id=67caa142&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67caa142",
  null
  
)

export default component.exports